export default __webpack_public_path__ + "static/media/April_08.481467ee.png";